module.exports = __webpack_public_path__ + "static/media/worldmap_green.55b36bd8.png";